export default {
  login: "api/token/",
  forgot: "api/password-reset-request/",
  reset: "api/password_reset/confirm/",
  invite:(id) => `api/accept-invitation/${id}/`,
  newpassword:(token) => `api/password-reset/${token}/`,
};
